export const iconFontAwesomeEditingEyeSlash = (
	<i className="fa-solid fa-eye-slash"></i>
);
